<template>
  <div class="main text-left">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"> <router-link to="/console">创作者中心</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ this.$t('lang.toolbar.Profile') }}</li>
      </ol>
    </nav>
    <div class="form-floating mb-3">
      <input type="text" class="form-control" id="floatingUsername" disabled="true"
        v-model="$store.state.userinfo.username" :placeholder="this.$t('lang.dict.username')">
      <label for="floatingUsername">{{ this.$t('lang.dict.username') }}</label>
    </div>

    <div class="form-floating mb-3">
      <input type="text" class="form-control" id="floatingMobile" v-model="input.mobile" :maxlength="13"
        :placeholder="this.$t('lang.dict.mobile')">
      <label for="floatingMobile">{{ this.$t('lang.dict.mobile') }}</label>
    </div>
    <div class="form-floating mb-3">
      <input type="email" class="form-control" id="floatingUsername" v-model="input.email" :maxlength="50"
        :placeholder="this.$t('lang.dict.email')">
      <label for="floatingUsername">{{ this.$t('lang.dict.email') }}</label>
    </div>
    <span class="btn btn-info" v-on:click="save()">{{ this.$t('lang.toolbar.OK') }}</span>
  </div>
</template>
<script>
import { Modal } from 'bootstrap'
import sx from '../../utils/core.js'
import $ from "jquery";

export default {
  data() {
    return {
      input: {
        mobile: '',
        email: ''
      }
    }
  },
  created() {
    this.$store.state.confirmdef = {
      title: this.$t('lang.toolbar.Confirm'),
      msg: this.$t('lang.msg.toContinue'),
      event: 'UpdateProfile'
    }
  },
  mounted() {
    const that = this;
    that.init();
  },
  methods: {
    toLogin() {
      this.$router.replace({ name: 'Login' })
    },
    init() {
      const that = this;
      const mymodal = sx.showWaiting()
      var params = {
        username: that.$store.state.userinfo.username,
        token: localStorage.getItem("token") || "token"
      }
      var url = that.$store.state.baseurl + '/app/authhelper/fetchAccount'
      sx.request(
        url,
        params,
        function (result) {
          if (result.status === 'ok') {
            if (result.data.rows.length > 0) {
              that.input.mobile = result.data.rows[0][1]
              that.input.email = result.data.rows[0][0]
            }
            sx.hideWaiting(mymodal)
          } else {
            sx.toastSuccess(result.message)
            console.log(result.message)
            sx.hideWaiting(mymodal)
          }
        },
        function () {
          console.log('error')
        }
      )
      sx.hideWaiting(mymodal)
    },
    save() {
      const that = this
      const myconfirmModal = new Modal(document.querySelector("#myModalConfirm"));
      myconfirmModal.show();
      $("#confirm").click(function () {
        myconfirmModal.hide();
        if (that.$store.state.confirmdef.event != "UpdateProfile") {
          return;
        }
        const mymodal = sx.showWaiting()
        var items = {}
        items.mobile = that.input.mobile
        items.email = that.input.email
        var params = {
          items: JSON.stringify(items),
          keys: JSON.stringify({
            username: that.$store.state.userinfo.username
          }),
          token: localStorage.getItem('token')
        }
        var url = that.$store.state.baseurl + '/app/authhelper/updateAccount'
        sx.request(
          url,
          params,
          function (result) {
            if (result.status === 'ok') {
              sx.toastSuccess(that.$t('lang.info.succeedUpdate'));
              sx.hideWaiting(mymodal)
            }
          },
          function (result) {
            console.log(result)
            sx.login(
              url,
              params,
              function (result) {
                if (result.status === 'ok') {
                  sx.toastSuccess(that.$t('lang.info.succeedUpdate'));
                } else {
                  sx.toastSuccess(result.message)
                  console.log(result.message)
                }
              }
            )
          }
        )
        sx.hideWaiting(mymodal)
      });
    }
  }
}
</script>
